import React from 'react'

const Cateringequerydata = () => {
    return (
        <div>

        </div>
    )
}

export default Cateringequerydata
